import { MapPointAPI } from '../../../api/datamanager/MapPointAPI';

export class MapPointsDraftCommand {
    getAll(edition, providerId, successCallback, errorCallback) {
        const apiResult = MapPointAPI.listDraft(edition.draftNetwork, providerId);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("[Rascunho] Ocorreu um erro a ler os Pontos Notáveis");
            }
        });
    }

    save(edition, mapPoint, successCallback, errorCallback) {
        let apiResult = undefined;
        let successMessage = "";

        if (undefined === mapPoint.id || 0 === mapPoint.id) {
            apiResult = MapPointAPI.createDraft(edition.draftNetwork, mapPoint);
            successMessage = "[Rascunho] Ponto Notável criado com sucesso";
        }
        else {
            apiResult = MapPointAPI.updateDraft(edition.draftNetwork, mapPoint.id, mapPoint);
            successMessage = "[Rascunho] Ponto Notável editado com sucesso";
        }
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                const output = {
                    message: successMessage,
                    data: undefined
                };

                try { output.data = JSON.parse(result); }
                catch (_) { }

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }

    delete(edition, mapPointId, successCallback, errorCallback) {
        const apiResult = MapPointAPI.deleteDraft(edition.draftNetwork, mapPointId);
        apiResult.then((_) => {
            if (undefined !== successCallback) {
                const output = {
                    message: "[Rascunho] Ponto Notável eliminado com sucesso",
                    data: undefined
                };

                successCallback(output);
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
